import { ListOutlined, MoreVertOutlined } from '@mui/icons-material';
import React, { useState } from 'react'
import { font } from '../../../styles/font';
import { Avatar, Box, IconButton, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import { ModulePath } from '../../../constant/ApplicationVariables';
import { LightTooltip } from '../../styled/CustomComponent';
import { OrganisationCustomIcon, ProjectCustomIcon } from '../../styled/CustomIcons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApplicationContext } from '../../../context/ApplicationContext';
import { memo } from 'react';

function ActiveOrganisationCard() {
    const { activeProject, setActiveProject, userDetail, setuserDetail, currentFolderData, setCurrentFolderData, toggleFolderSidebar, setToggleFolderSidebar } = useApplicationContext();

    const theme = useTheme();
    const navigate = useNavigate();
    const pathName = useLocation()?.pathname

    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);

    const handleToggleMoreMenu = (event) => {
        if (moreMenuAnchorEl) {
            setMoreMenuAnchorEl(null);
        } else {
            setMoreMenuAnchorEl(event.currentTarget);
        }
    }

    const handleViewAllItems = () => {
        setCurrentFolderData(null);
    }

    console.log(activeProject, "activeProject")

    return (
        <Box className="flex items-center  gap-0 w-full h-full overflow-hidden" >
            {!toggleFolderSidebar ?
                <Box className="flex items-center  gap-0 w-full h-full">
                    <LightTooltip
                        title={activeProject?.name}
                        placement="right"
                        arrow
                    >
                        <Avatar variant="rounded" title={`${userDetail?.companyName}`} sx={{ background: theme.palette.secondary.main, color: theme.palette.secondary.contrastText }}>
                            <Typography fontSize={font.size.fs_4} fontWeight={600} color="inherit" className="uppercase">{userDetail?.companyName[0]}</Typography>
                        </Avatar>
                    </LightTooltip>
                </Box>
                :
                <Box className="flex items-center  gap-0 w-full h-full overflow-hidden" bgcolor={theme.palette.background.custom} borderRadius={theme.shape.borderRadius}>
                    <Box className="flex-1 h-full flex items-center px-4 py-4  gap-2  overflow-hidden max-w-[88.5%]">
                        <Avatar variant="rounded" sx={{ background: theme.palette.secondary.main, color: theme.palette.secondary.contrastText }}>
                            <OrganisationCustomIcon sx={{ fontSize: font.size.fs_2, color: "inherit" }} />
                        </Avatar>


                        <Box className=" flex flex-col justify-between flex-1 w-auto gap-1 overflow-hidden" >
                            <LightTooltip
                                title={activeProject?.name}
                                placement="right"
                                arrow
                            >
                                <Typography fontWeight={600} sx={{ color: theme.palette.text.primary }}>{userDetail?.companyName || "Organisation Name"}</Typography>
                            </LightTooltip>
                            {/* <Typography fontSize={font.size.fs_5} lineHeight={font.size.fs_5} sx={{ color: theme.palette.text.ternary }}>{"Project"}</Typography> */}
                            {/* <LightTooltip
                                title={activeProject?.description}
                                placement="right"
                            >
                                <Typography lineHeight={font.size.fs_5} className="flex-1 line-clamp-1" sx={{ color: theme.palette.text.ternary }}>{activeProject?.description || "Description"}</Typography>
                            </LightTooltip> */}
                        </Box>

                    </Box>

                    {/* <Box className=" min-w-10 w-fit max-w-10  h-full flex flex-col  items-center justify-center  px-0 py-0 gap-0 ">


                        <IconButton onClick={handleToggleMoreMenu}>
                            <MoreVertOutlined sx={{ fontSize: font.size.fs_3 }} />
                        </IconButton>

                        <IconButton disabled={!(pathName === ModulePath.requirements || pathName === ModulePath.useCase || pathName === ModulePath.testCase)} color={!currentFolderData ? "secondary" : "default"} onClick={handleViewAllItems}>
                            <ListOutlined sx={{ fontSize: font.size.fs_3 }} />
                        </IconButton>
                    </Box> */}
                </Box>
            }

            <Menu
                open={Boolean(moreMenuAnchorEl)}
                anchorEl={moreMenuAnchorEl}
                onClose={handleToggleMoreMenu}
            >
                <MenuItem onClick={() => navigate(ModulePath.configuration)}>Project</MenuItem>
                <MenuItem onClick={() => navigate(ModulePath.configuration)}>Labels</MenuItem>
            </Menu>
        </Box>
    )
}

export default memo(ActiveOrganisationCard)